import ModelCategoryRadio from './ModelCategoryRadio'

export default ModelCategoryRadio
